import * as React from 'react';

var _g, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgZkSync = function SvgZkSync(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _g || (_g = /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#clip0_839_5423)"
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: 60,
        cy: 60,
        r: 60,
        fill: "#2D2D2D"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m74 41.5 18.5 18L74 78V68H56.5L74 55zM46.5 78 28 60l18.5-18.5v10H64l-17.5 13z"
    }))), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "clip0_839_5423"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 .031h120v120H0z"
    })))));
};

export { SvgZkSync as ReactComponent };
//# sourceMappingURL=ZKSync.svg.es.js.map
